import React from 'react';

import { paymentTermsShape } from '../../prop-types';

function PaymentTermsLabel({ model }) {
  return <div className="mt-2">{model.name}</div>;
}

PaymentTermsLabel.propTypes = {
  model: paymentTermsShape.isRequired,
};

export default PaymentTermsLabel;
